import axios from 'axios';
import config from '../utils/config';

axios.defaults.baseURL = config.getBaseUrl();
axios.defaults.headers.post['Content-Type'] = 'application/json';

// Add a global request interceptor to set 'x-source' header for SSO users
axios.interceptors.request.use(
  function (config) {
    try {
      const userStr = localStorage.getItem('user');
      if (userStr) {
        const user = JSON.parse(userStr);
        if (user?.lionLoginInfo || user?.isSSO) {
          config.headers = config.headers || {};
          config.headers['x-source'] = 'sso';
        }
        if (user?.appId) {
          config.headers['x-app'] = user?.appId
        }
      }

    } catch (e) {
      // fail silently, don't block request
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default axios;
